module.exports = __webpack_public_path__ + "static/media/bg-image-18.77621217.jpg";